export { ErrorPageComponent } from './error-pages.component';
